const PortfolioDatas = [
    {Title:'Projets CodePen',
    Subtitle: 'Un tas de Projets sur CodePen',
    Description:'Vous pouvez trouver sur mon Codepen plusieurs petit projet ! Notamment des design pour des modalBox, des appels api ou des menus déroulant. Je pense que ces petits projet sont important pour développer la créativité et tester de nouvelles solutions.', 
    Techno : 'Javascript',
    img : 'codepen.png',
    link : 'https://codepen.io/Keymo'},
    {Title:'L\'ODS 35',
    Subtitle: 'Un Projet pour une association.',
    Description:'Pour ce projet nous étions par groupe de 4. L\'objectif était de créer un site de présentation pour l\'organisme de l\'ODS 35. La contrainte était que le site devait être éditable et potentiellement modifiable par une autre équipe de développeurs. Nous avons donc fait le choix évident d\'utiliser WordPress.', 
    Techno : 'Wordpress',
    img : 'odsscreen.jpg',
    link : 'https://github.com/Isorethan/ods35-custome-theme'},
    {Title:'Projet data Passing JS',
    Subtitle: 'Un projet pour s\'entrainer',
    Description:'L\'objectif de ce projet était de faire passer les contenu des éléments HTML des cartes vers la homepage. On pourrait aussi imaginer des version alternatives avec les attributs HTML data-.', 
    Techno : 'HTML/CSS/JS',
    img : 'mini_projet.jpg',
    link : 'https://mini-projet-js-1.netlify.app/'},
    {Title:'WebAgency',
    Subtitle: 'Ma première Réalisation !',
    Description:'Voici un projet réalisé lors d\'une formation développeur web Il s\'agit d\'une simple one page en pur HTML/CSS La page devait être responsive et intégré un slider.', 
    Techno : 'HTML/CSS',
    img : 'webagency.png',
    link : 'https://github.com/KeymoKawaii/WebAgency'},
    {Title:'Mon Portfolio',
    Subtitle: 'Parce qu\'un Portfolio c\'est déjà un projet en soit !',
    Description:'Portfolio Réalisé avec React js. Utilisation des props, state et import dynamique ! Les base du Framework', 
    Techno : 'ReactJS',
    img : 'banner.png',
    link : 'https://github.com/KeymoKawaii/Porfolio'}, 
     ];

export default PortfolioDatas;